import {ChangeDetectionStrategy, Component, Inject, OnInit} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {select, Store} from '@ngrx/store';
import {SbbButton} from '@sbb-esta/lyne-angular/button';
import {SbbSecondaryButton} from '@sbb-esta/lyne-angular/button';
import {SBB_OVERLAY_DATA} from '@sbb-esta/lyne-angular/core/overlay';
import {SbbDialogContent, SbbDialogTitle, SbbDialogActions, SbbDialogRef} from '@sbb-esta/lyne-angular/dialog';
import {SbbLink} from '@sbb-esta/lyne-angular/link';
import {BenutzerProfilEinstellungenApiModel} from 'cargo-hub-ui-customer-api';
import {DateService} from '../../services/date/date.service';
import {changeUserProfileSettings, logoutAction} from '../auth-store/auth.actions';
import {selectUserProfileSettings} from '../auth-store/auth.selectors';

@UntilDestroy()
@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SbbDialogTitle, SbbDialogContent, SbbDialogActions, SbbButton, SbbSecondaryButton, SbbLink]
})
export class TermsAndConditionsComponent implements OnInit {
  private readonly DEFAULT_SETTINGS: BenutzerProfilEinstellungenApiModel = {
    allgemeineGeschaeftsbedingungen: {
      timeStampZuletztAktzeptiert: DateService.dateTimeToUTCDateTime(new Date()),
      aktuelleAllgemeineGeschaeftsbedingungenAkzeptiert: true
    },
    sessionRecording: {
      datumZuletztGeaendert: DateService.dateTimeToUTCDateTime(new Date()),
      sessionRecordingAktiv: true
    }
  };
  private settings: BenutzerProfilEinstellungenApiModel | null = null;

  readonly isFirstTimeAcceptance: boolean = false;

  constructor(
    private store: Store,
    public dialogRef: SbbDialogRef<TermsAndConditionsComponent>,
    @Inject(SBB_OVERLAY_DATA) dialogData: {isFirstTimeAcceptance: boolean}
  ) {
    this.isFirstTimeAcceptance = dialogData.isFirstTimeAcceptance;
  }

  ngOnInit() {
    this.store.pipe(select(selectUserProfileSettings), untilDestroyed(this)).subscribe(settings => (this.settings = settings));
  }

  acceptTermsAndConditions() {
    this.store.dispatch(
      changeUserProfileSettings({
        payload: {
          ...this.DEFAULT_SETTINGS,
          ...this.settings,
          allgemeineGeschaeftsbedingungen: {
            timeStampZuletztAktzeptiert: DateService.dateTimeToUTCDateTime(new Date()),
            aktuelleAllgemeineGeschaeftsbedingungenAkzeptiert: true
          }
        }
      })
    );
    this.dialogRef.close(true);
  }

  logout() {
    this.store.dispatch(logoutAction());
    this.dialogRef.close(true);
  }
}
